const adZones = ['380', '381'];

export default adZones;
